import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TextField from '@material-ui/core/TextField';
import Toolbar from '@material-ui/core/Toolbar';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import RentTable from '../Rent/RentTable';
import BikeTable from '../Bike/BikeTable';
import {
  getUsers,
  getUsersRenters,
  putUser,
  postWaitingUser,
  getWaitingUsers
} from '../../store/users/actions';
import RenterAdminTableHead from '../Users/RenterAdminTableHead';
import RenterAdminRow from '../Users/RenterAdminRow';
import KobooDialog from '../Layout/KobooDialog.jsx';
import KobooButton from '../Layout/KobooButton';
import SiteTable from '../Site/SiteTable';

const styles = () => ({
  tableParent: {
    width: '100%',
    overflowX: 'auto',
    marginBottom: '2vh',
  },
  table: {
    minWidth: 500,
  },
  wrapper: {
    overflow: 'hidden',
    marginBottom: '2vh',
  },
  floating: {
    float: 'left',
    marginRight: '2vh',
    marginBottom: '2vh',
  }
});

const INITIAL_STATE = {
  dialog: {
    open: false,
    item: '',
  }
};

export class RenterDetails extends Component {
  constructor(props) {
    super(props);
    this.state = { ...INITIAL_STATE };
  }

  static propTypes = {
    renter: PropTypes.object.isRequired,
    bikes: PropTypes.array.isRequired,
    sites: PropTypes.array.isRequired,
    classes: PropTypes.object.isRequired,
    authUser: PropTypes.object,
    users: PropTypes.object || PropTypes.array,
    waitingUsers: PropTypes.array
  };

  static getDerivedStateFromProps(props) {
    if (!props.users && !props.pending) {
      props.getUsers().then(
        props.getUsersRenters()
      );
    }

    if (props.authUser && props.authUser.ma && !props.waitingUsers && !props.pendingWU) {
      props.getWaitingUsers(props.authUser.ma, props.renter.id);
    }

    if (props.sites && props.bikes) {
      props.bikes.forEach((bike) => {
        const bikeSite =props.sites.find(site => site.id === bike.site_id);
        if (bikeSite) {
          bike.siteName = bikeSite.name;
          bike.siteType = bikeSite.type;
        }
      });
    }

    if (props.renters && props.bikes) {
      props.bikes.forEach((bike) => {
        bike.renterName = props.renters
          .find(renter => renter.id === bike.renter_info_id).name;
      });
    }
    return null;
  }

  // Handler

  handleClose = () => {
    this.setState({ ...INITIAL_STATE });
  };

  handleClickOpen = () => {
    this.setState({ dialog: {
        ...this.state.dialog,
      open: true,

    }});
  };

  handleClickInviteAdmin = (event) => {
    this.handleClose();
    this.props.postWaitingUser(
      this.props.authUser.ma,
      this.props.renter.id,
      {
        email: this.state.dialog.item,
      },
    );
    event.preventDefault();
  };

    render() {
      const {
        classes, renter, bikes, sites, users, waitingUsers, sitesPending
      } = this.props;

      const renterAdmins = [];
      if (users) {
        Object.keys(users).filter(userId => users[userId].renter_id === renter.id)
          .map(userId => (
            renterAdmins.push({
              ...users[userId],
              id: userId
            })
          ));
      }
      const renterWaitingUsers =! waitingUsers ? [] :
        waitingUsers.filter(waitingUser => waitingUser.renter_id === renter.id);
      const alreadyExistsDialogItem =
        renterAdmins
          .filter(renterAdmin => renterAdmin.email === this.state.dialog.item).length > 0 ||
        renterWaitingUsers.filter(renterWaitingUser =>
          renterWaitingUser.email === this.state.dialog.item ).length > 0;

      return (
        <div>
          <Typography variant="h6" gutterBottom>Informations</Typography>
          <div className={classes.tableParent}>
            <Table className={classes.table}>
              <TableHead>
                <TableRow>
                  <TableCell>Nom</TableCell>
                  <TableCell>Rib</TableCell>
                  <TableCell>Mail</TableCell>
                  <TableCell>Délai embargo (en minutes)</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell>{renter.name}</TableCell>
                  <TableCell>{renter.rib}</TableCell>
                  <TableCell>{renter.mail}</TableCell>
                  <TableCell>{Math.round(renter.max_time_before_embargo  / 60)}</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </div>

          <div className={classes.wrapper}>
            <Typography
              className={classes.floating}
              variant="h6"
              gutterBottom>
              Administrateurs
            </Typography>
            <KobooDialog
              open={this.state.dialog.open}
              handleClose={this.handleClose}
              dialogTitle="Voulez-vous inviter un nouvel administrateur pour ce loueur ?"
              handleCloseCancel={this.handleClose}
              handleCloseOK={event => this.handleClickInviteAdmin(event)}
              textField={ <TextField
                value={ this.state.dialog.item }
                onChange={ event => this.setState({dialog: {
                    ...this.state.dialog,
                    item: event.target.value
                  }
                })}
                className={classes.textField}
                InputProps= {{
                    className: classes.input,
                  }}
                label="email"
                placeholder="email"
                helperText={alreadyExistsDialogItem ?
                  "Cet utilisateur a déjà été invité pour administrer ce loueur" : ""}
                id={renter.id}
                type="text"
                margin="normal"
                error={alreadyExistsDialogItem}

              /> }
              cancelText="ANNULER"
              okText="VALIDER"
              disabled={alreadyExistsDialogItem}
            />
          </div><div className={classes.tableParent}>
              <Toolbar>
                <KobooButton onClick={this.handleClickOpen}>
                  Ajouter un administrateur
                </KobooButton>
              </Toolbar>

          {(renterAdmins.length || renterWaitingUsers.length)
            ?
          <Table className={classes.table}>
                <RenterAdminTableHead/>
                <TableBody>
                  {renterAdmins
                    .map(renterAdmin => (
                      <RenterAdminRow
                        key={ renterAdmin.id}
                        user={ renterAdmin }
                        isWaiting={ false }
                      />
                  ))}
                  {renterWaitingUsers
                      .map(waitingUser => (
                        <RenterAdminRow
                          key={ waitingUser.email}
                          user={ waitingUser }
                          isWaiting={ true }
                        />
                      ))
                  }
                </TableBody>
              </Table>: <Typography variant="subtitle1">Aucun administrateur</Typography>
          }
          </div>

          <Typography variant="h6" gutterBottom>Sites</Typography>
          <div className={classes.tableParent}>
            <SiteTable
              renters={[renter]}
              sites={sites}
            />
          </div>
          <Typography variant="h6" gutterBottom>Vélos</Typography>
          <div className={classes.tableParent}>
            <BikeTable
              bikes={ bikes }
              isInBikePage={ false }
              pending={sitesPending}
            />
          </div>
          <Typography variant="h6" gutterBottom>Locations</Typography>
          <div className={classes.tableParent}>
            <RentTable
              bikes={bikes}
              sites={sites}
              renters ={[renter]}
            />
          </div>
        </div>
      );
    }
}

function mapStateToProps(state) {
  return {
    authUser: state.users.authUser,
    pending: state.users.pending,
    sending: state.users.sending,
    users: state.users.content,
    error: state.users.error,
    waitingUsers: state.users.waitingUsers,
    pendingWU: state.users.pendingWU,
    sitesPending: state.sites.pending
  };
}

export default compose(
  withStyles(styles),
  connect(mapStateToProps, {
    getUsers, putUser, getUsersRenters,
    getWaitingUsers, postWaitingUser
  })
)(RenterDetails);



// WEBPACK FOOTER //
// ./src/components/Renter/RenterDetails.jsx